import { render, staticRenderFns } from "./SingleDatasetSelector.vue?vue&type=template&id=19507f58&scoped=true&"
import script from "./SingleDatasetSelector.vue?vue&type=script&lang=js&"
export * from "./SingleDatasetSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19507f58",
  null
  
)

export default component.exports